import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface RequireApprovedProps {
  children: ReactNode;
}

const RequireApproved = ({ children }: RequireApprovedProps) => {
  const { isAuthenticated, loading, profile, profileLoading, profileError, refreshProfile } = useAuth();
  const location = useLocation();

  if (loading || profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Carregando permissões...</p>
      </div>
    );
  }

  if (profileError) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="space-y-3 text-center">
          <p className="text-sm font-semibold text-destructive">Não foi possível carregar seu perfil.</p>
          <p className="text-xs text-muted-foreground">Tente novamente para validar seu acesso.</p>
          <button
            onClick={() => refreshProfile().catch(() => {})}
            className="rounded-md bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground shadow-sm"
          >
            Recarregar status
          </button>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!profile || !profile.approved) {
    return <Navigate to="/pending" replace />;
  }

  return <>{children}</>;
};

export default RequireApproved;


